module.exports = __webpack_public_path__ + "img/keynote_1-sm.b05256e0.png";